import { AnalyticsService } from 'acerto-ds-services';

import storageService from './StorageService';

export default new AnalyticsService(storageService.meuacerto);
